// @ts-nocheck
class AccordionDetails extends HTMLElement {
  constructor() {
    super();
    this.allowMultiple = this.hasAttribute('allow-multiple');
    this.isOpen = false;
  }

  connectedCallback() {
    this.contentEl = this.querySelector('accordion-content');

    // Set initial aria-expanded state
    this.setAttribute('aria-expanded', 'false');

    // Initialize content state
    this.initializeContent();

    // If the element has the 'open' attribute, start expanded (next frame for accurate height)
    if (this.hasAttribute('open')) {
      requestAnimationFrame(() => this.open());
    }
  }

  initializeContent() {
    if (this.contentEl) {
      this.isOpen = false;
      if (typeof this.contentEl.collapse === 'function') {
        this.contentEl.collapse();
      } else if (this.contentEl instanceof HTMLElement) {
        this.contentEl.style.setProperty('max-height', '0px', 'important');
      }
    }
  }

  // Method to open accordion
  open() {
    this.isOpen = true;
    this.classList.add('active');
    this.setAttribute('aria-expanded', 'true');
    this.setAttribute('open', '');

    if (this.contentEl && typeof this.contentEl.expand === 'function') {
      this.contentEl.expand();
    } else if (this.contentEl && this.contentEl instanceof HTMLElement) {
      const targetHeight = this.contentEl.scrollHeight;
      this.contentEl.style.setProperty(
        'max-height',
        targetHeight + 'px',
        'important',
      );
    }
  }

  // Method to close accordion
  close() {
    this.isOpen = false;
    this.classList.remove('active');
    this.setAttribute('aria-expanded', 'false');
    this.removeAttribute('open');

    if (this.contentEl && typeof this.contentEl.collapse === 'function') {
      this.contentEl.collapse();
    } else if (this.contentEl && this.contentEl instanceof HTMLElement) {
      this.contentEl.style.setProperty('max-height', '0px', 'important');
    }
  }

  // Method to toggle accordion
  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  // Icon visibility/rotation fully controlled via Tailwind group/aria in markup
}

customElements.define('accordion-details', AccordionDetails);

class AccordionSummary extends HTMLElement {
  constructor() {
    super();
    // Bind methods to preserve context
    this.handleToggle = this.handleToggle.bind(this);
  }

  connectedCallback() {
    this.accordionDetails = this.closest('accordion-details');
    this.bindEvents();
  }

  bindEvents() {
    this.addEventListener('click', this.handleToggle);
  }

  disconnectedCallback() {
    // Clean up event listeners
    this.removeEventListener('click', this.handleToggle);
  }

  handleToggle(e) {
    e.preventDefault();

    if (!this.accordionDetails) {
      console.error('❌ No accordion-details parent found');
      return;
    }

    if (typeof this.accordionDetails.toggle !== 'function') {
      console.error('❌ Accordion details element is missing toggle method');
      return;
    }

    const allowMultiple = this.accordionDetails.allowMultiple;
    const isCurrentlyOpen = this.accordionDetails.isOpen;

    // If not allowing multiple, close all other accordions first
    if (!allowMultiple && !isCurrentlyOpen) {
      const accordionGroup =
        this.accordionDetails.closest('[data-accordion-group]') || document;
      const accordionItems =
        accordionGroup.querySelectorAll('accordion-details');

      accordionItems.forEach((item) => {
        if (
          item !== this.accordionDetails &&
          item?.isOpen &&
          typeof item?.close === 'function'
        ) {
          item?.close();
        }
      });
    }

    // Toggle this accordion
    this.accordionDetails?.toggle();
  }
}

customElements.define('accordion-summary', AccordionSummary);

class AccordionContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Start collapsed (Tailwind handles overflow/transition)
    this.collapse();
  }

  expand() {
    // Ensure we start from 0 for the animation
    const startFromZero =
      this.style.maxHeight === '' || this.style.maxHeight === '0px';
    if (startFromZero) {
      this.style.setProperty('max-height', '0px', 'important');
      // Force reflow so the browser registers the starting 0 height
      // eslint-disable-next-line no-unused-expressions
      this.offsetHeight;
    }
    // Measure natural height
    this.style.setProperty('max-height', 'none', 'important');
    const target = this.scrollHeight;
    // Reset back to 0 before animating up to target
    if (startFromZero) this.style.setProperty('max-height', '0px', 'important');
    // Next frame, animate up to measured height
    requestAnimationFrame(() => {
      this.style.setProperty('max-height', target + 'px', 'important');
    });
  }

  collapse() {
    this.style.setProperty('max-height', '0px', 'important');
  }

  bindEvents() {}
  disconnectedCallback() {}
}

customElements.define('accordion-content', AccordionContent);
